import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { UtilityTarget } from "../models/UtilityTarget";

export const getUtilityTargets = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SWV].[GetUtilityTargets]", [], signal);

	if (resp.ok) {
		return (get(resp, "data.tables.0.rows", []) as UtilityTarget[]).map(
			(row) => ({ ...row, IsMill: !!row.IsMill }),
		);
	} else {
		throw new Error(resp.message || "Error fetching utility targets");
	}
};
